import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de382f076e10cb/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de382f076e10cb/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de382f076e10cb/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFAQ"] */ "/tmp/8de382f076e10cb/components/sections/KioskFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de382f076e10cb/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/app/[locale]/industries/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de382f076e10cb/node_modules/next/dist/client/link.js");
